
<nova-detail-toolbar [template]="toolbarTemplate" [showBackButton]="false"></nova-detail-toolbar>
  <ng-template #toolbarTemplate>
        <div class="nova-toolbar__title"> {{ title }}</div>
  </ng-template>
  <mat-progress-bar mode="indeterminate" *ngIf="isLoading | async"></mat-progress-bar>
  <div style="margin: 15px 15px 15px 15px;" class="wizard flex-row">
    <div class="flex-20">
      <button mat-raised-button color="default" class="wizard-back-button" (click)="goToPreviousStep()" data-qa-id="WizardBackButton1">
          <mat-icon class="material-icons arrow-back">arrow_back</mat-icon> Back
      </button>
    </div>
    <div class="flex-20" style="text-align: center">
      <p class="wizard-step-title"><strong>STEP {{ stepIndex }} OF {{ lastStepIndex }}</strong></p>
      <p><strong>{{ stepSubTitle }}</strong></p>
    </div>
    <div class="next-step flex-20">
      <button mat-raised-button color="primary" class="wizard-next-button" data-qa-id="WizardNextButton" (click)="goToNextStep()">
        {{ nextButtonText }} <mat-icon class="material-icons arrow-back">arrow_forward</mat-icon>
      </button>
      <button mat-raised-button color="primary" class="wizard-next-button-2" *ngIf="isNextButton2Enabled" (click)="goToNextStep2()">
        {{ nextButton2Text }} <mat-icon class="material-icons arrow-back">arrow_forward</mat-icon>
      </button>
    </div>
  </div>
  <ng-content></ng-content>